import React from 'react'
import { StyledLabel } from './UserSettingsCheckbox.styled'

interface UserSettingsCheckboxProps {
    name: string
    label: string
    checked: boolean
    size: number
    disabled?: boolean
    width?: string
    onChange?: (checked: boolean) => void
}

export const UserSettingsCheckbox: React.FC<UserSettingsCheckboxProps> = (
    props,
) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) props.onChange(e.target.checked)
    }

    return (
        <StyledLabel size={props.size} width={props.width}>
            <div>
                <input
                    type="checkbox"
                    name={props.name.toLowerCase()}
                    checked={props.checked}
                    disabled={props.disabled}
                    width={props.width}
                    onChange={handleChange}
                />
            </div>
            {props.label}
        </StyledLabel>
    )
}
UserSettingsCheckbox.displayName = 'TNCheckbox'
